import React, { useCallback, useMemo, useState } from 'react';
import { SaveContextProvider, Toolbar, SaveButton, SimpleForm, FileInput, FileField, required, useDataProvider, useNotify, useRedirect } from 'react-admin';
import DownloadDayTypesTemplateButton from './DownloadDayTypesTemplateButton';

const DayTypesImportForm = props => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const redirect = useRedirect();
    const [saving, setSaving] = useState();
    const [importError, setImportError] = useState();

    const handleFail = useCallback((a) => {
        notify('Unknown error, see console', 'error');
        console.log(a);
    }, [notify]);

    const handleSave = useCallback((values) => {
        setSaving(true);
        dataProvider.createMultipart(
            `day-types-import`,
            { data: values }
        ).then((result) => {
            setSaving(false);
            setImportError(false);
            const { created = [], skipped_existing: skipped = [] } = result.data ?? {};
            notify(
                `Imported ${created.length} day type${created.length === 1 ? '' : 's'}`
                + (skipped.length > 0 ? `, skipped ${skipped.length} already existing (${skipped.join(', ')})` : ''),
                'success'
            );
            redirect(`/day-types`);
        }).catch((error) => {
            console.log(error);
            setSaving(false);
            if (error.body.errors) {
                setImportError(error.body);
            } else {
                notify(JSON.stringify(error.body));
            }
        })
    }, [dataProvider, notify, redirect]);

    const saveContext = useMemo(() => ({
        save: handleSave,
        setOnFailure: handleFail,
        saving
    }), [saving, handleSave, handleFail]);

    const ImportErrorRow = ({ error }) => (
        <tr>
            <td>{error.row === 0 ? '—' : error.row}</td>
            <td>{Array.isArray(error.errors) ? error.errors.join(' ') : error.errors}</td>
        </tr>
    );
    const ImportErrorList = () => (<>
        <p>Errors were encountered when processing this spreadsheet. Nothing was imported — fix the rows below and re-upload.</p>
        <table style={{ "width": "100%" }}>
            <thead>
                <tr>
                    <th>Row No.</th>
                    <th>Error Message</th>
                </tr>
            </thead>
            <tbody>
                {importError.errors.map((error, index) => (<ImportErrorRow error={error} key={index} />))}
            </tbody>
        </table>
    </>);

    let errorOutput = (<></>);
    if (importError) {
        errorOutput = (<ImportErrorList />);
    }

    const ImportToolbar = props => (
        <Toolbar {...props} >
            <SaveButton
                label="Import Day Types"
                redirect={false}
                submitOnEnter={false}
                variant="text"
            />
        </Toolbar>
    );

    return (<>
        {errorOutput}
        <SaveContextProvider value={saveContext}>
            <DownloadDayTypesTemplateButton />
            <SimpleForm toolbar={<ImportToolbar />} save={handleSave}>
                <FileInput source="import" label="Upload file (.xlsx)" multiple={false} accept=".xlsx" validate={required()}>
                    <FileField source="src" title="title" />
                </FileInput>
            </SimpleForm>
        </SaveContextProvider>
    </>);

};

export default DayTypesImportForm;
